// This file was generated by lezer-generator. You probably shouldn't edit it.
import { LRParser } from '@lezer/lr';
import { rubyTemplateHighlight } from './highlight';
export const parser = LRParser.deserialize({
  version: 14,
  states:
    "%QOQOPOOOOOO'#C_'#C_OOOO'#Cl'#ClO!WOPO'#C^OOOO'#Cw'#CwOOOO'#Cg'#CgO!_OPO'#CbOOOO'#Ci'#CiOOOO'#Cc'#CcQQOPOOO!}OPO'#CsO#jOPO'#CvOOOO'#Cr'#CrOOOO'#Cd'#CdO#qOPO'#C`O#xOPO,58xOOOO-E6e-E6eOOOO-E6a-E6aOOOO'#Ce'#CeO#}OPO,59_OOOO,59_,59_OOOO'#Cf'#CfO$UOPO,59bOOOO,59b,59bOOOO-E6b-E6bOOOO'#Ca'#CaOOOO1G.d1G.dOOOO-E6c-E6cOOOO1G.y1G.yOOOO-E6d-E6dOOOO1G.|1G.|",
  stateData:
    '$]~O_POaQObQOcQOdQOeQOhSOiSO~O_POaQObQOcQOdQOeQOhYOiZO~O^SP~PlO[UX_UX~PTOaQObQOcQOdQOeQOibO~OhdO~P!iOaQObQOcQOdQOeQOheO~OigO~P#UO^SX~PlO^iO~OhlO~P!iOinO~P#UO',
  goto:
    '#flPPmu{!O!R!V!]!c!i!oP!vPP!zPPPPPq#]PP#]#aSVOXT]R^XRORX^R_RRj_TVOXQXORaXQ^RRh^QcYRkcQfZRmfSUOXR`UTWOXUSOUXS]R^SbYcTeZfT[R^VTOUX',
  nodeNames:
    '⚠ Template TemplateExpr TemplateStart TemplateContent TemplateEnd Text',
  maxTerm: 27,
  propSources: [rubyTemplateHighlight],
  skippedNodes: [0],
  repeatNodeCount: 5,
  tokenData:
    "#_~R]Orzrs!Psuzuv!Uvwzwx!cx!^z!^!_!h!_!`!}!`!a#S!a;'Sz;'S;=`#X<%lOz~!POa~~!UOh~~!ZPd~!`!a!^~!cO^~~!hOi~~!mPb~uv!p~!uP_~!_!`!x~!}O_~~#SOe~~#XOc~~#[P;=`<%lz",
  tokenizers: [0],
  topRules: { Template: [0, 1] },
  tokenPrec: 0,
});
